import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { CurrentUser } from '../../auth/api/auth';

const SUPPORT_VIEW_STORAGE_KEY = 'crowpeaks-support-view';

interface SupportViewState {
  isActive: boolean;
  operatorAccessToken: string | null;
  operatorUser: CurrentUser | null;
  companyName: string | null;
  tenantId: string | null;
  expiresAtMs: number | null;
  setActiveSession: (session: {
    operatorAccessToken: string;
    operatorUser: CurrentUser;
    companyName: string;
    tenantId: string;
    expiresAtMs: number;
  }) => void;
  clear: () => void;
}

const initialState = {
  isActive: false,
  operatorAccessToken: null,
  operatorUser: null,
  companyName: null,
  tenantId: null,
  expiresAtMs: null,
} as const;

export const useSupportViewStore = create<SupportViewState>()(
  persist(
    (set) => ({
      ...initialState,
      setActiveSession: (session) =>
        set({
          isActive: true,
          operatorAccessToken: session.operatorAccessToken,
          operatorUser: session.operatorUser,
          companyName: session.companyName,
          tenantId: session.tenantId,
          expiresAtMs: session.expiresAtMs,
        }),
      clear: () => set({ ...initialState }),
    }),
    {
      name: SUPPORT_VIEW_STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        isActive: state.isActive,
        operatorAccessToken: state.operatorAccessToken,
        operatorUser: state.operatorUser,
        companyName: state.companyName,
        tenantId: state.tenantId,
        expiresAtMs: state.expiresAtMs,
      }),
    }
  )
);

export function isSupportViewActive(): boolean {
  return useSupportViewStore.getState().isActive;
}
